module.exports = __webpack_public_path__ + "static/media/nurse-enrolled.e70f13a6.jpg";